module.exports = __webpack_public_path__ + "img/card2hover.3e98e8c0.svg";